import { createAction } from "@reduxjs/toolkit";

export const setDefaultBlockchainId = createAction<number>(
    "API/WEB3/SET_DEFAULT_BLOCKCHAIN_ID",
);
